import { InjectionToken } from '@angular/core';
import { Ab } from '@df/module-ab/ab.namespace';

export const AB_OPTIONS = new InjectionToken<Ab.IOptions>('AB_OPTIONS');
